import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'

export const useGetAuthClaims = () => {
    const { isAuthenticated, user, getIdTokenClaims } = useAuth0()
    return useQuery({
        queryKey: ['user_claims', user],
        enabled: isAuthenticated && !!user,
        queryFn: async () => {
            const idTokenClaims = await getIdTokenClaims()
            return idTokenClaims
        },
    })
}

export const useGetAccessToken = () => {
    const { isAuthenticated, user, getAccessTokenSilently } = useAuth0()
    return useQuery({
        queryKey: ['access_token', user],
        enabled: isAuthenticated && !!user,
        queryFn: async () => {
            const token = await getAccessTokenSilently()
            return token
        },
    })
}
